import { useLogoutFunction } from '@propelauth/react';
import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useLogout = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const logoutFn = useLogoutFunction();

  const logout = async () => {
    const fetchConfig = getFetchConfig({ method: FetchMethod.POST });
    await fetch(`${APIBaseChronos}/api/auth/logout`, fetchConfig);
  };

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      logoutFn(true);
    },
  });
};
